<!--在线监管-实时管理-一点一档-->
<template>
  <div class="notification_dialog">
    <div class="notification_dialog_content" ref="notificationDialog" >
      <div style="text-align: center; margin-top: -30px; background-color: white; z-index: 1; position: sticky; top: 0;">
        <h2>一点一档</h2>
      </div>
      <el-form style="width: 99%">
        <el-row :gutter="20" >
          <el-col :span="10">
            <el-form-item label="餐饮企业名称：">
              <el-tooltip class="item" effect="dark" :content="device.name" placement="top">
                <span
                  style="white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 16em;
                  display: block;">
                  {{ device.name }}
                </span>
              </el-tooltip>
            </el-form-item>

          </el-col>
          <el-col :span="6" style="margin-top: 10px">
              <span>联系人：</span>
              <span v-if="customForm.Contact">
                <span>{{ customForm.Contact }}</span>
              </span>

          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话：">
              <span>{{ customForm.Mobile }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="10">
            <el-form-item label="详细地址：">
              <el-tooltip class="item" effect="dark" :content="device.addr" placement="top">
                <span
                style="white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 17em;
                display: block;"
                >
                  {{ device.addr }}
                </span>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 10px">
            <span>监测点类型：</span>
              <span>{{ device.status | filter }}</span>

          </el-col>
          <el-col :span="6">
            <el-form-item label="所属单位:">
              <span
              style="white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 20em;
              display: block;"
              >
                  <el-tooltip class="item" effect="dark" :content="device.owner_name" placement="top">
                    <span
                      style="white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 20em;
                      display: block;"
                    >
                      {{ device.owner_name }}
                      </span>
                  </el-tooltip>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="20" >
          <el-col :span="10">
            <el-form-item label="菜系：">
              <span>{{ transformCuisine(device.cuisine) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 10px">
            <span>风速：</span>
              <span>{{ device.fan_speed }} m/s</span>

          </el-col>
          <el-col :span="6">
            <el-form-item label="风量：">
              <span>{{ device.fan_quantity }} m³/h</span>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="管道截面面积：">
              <span>{{ device.pipe_area }} m²</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 10px">
            <span>灶头数量：</span>
              <span>{{ device.stove_num }} 个</span>

          </el-col>
          <el-col :span="6">
            <el-form-item label="集气罩面积：">
              <span>{{ device.stove_area }} m²</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <h4>一、技术指导：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="guideData"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="cuisine" label="菜系" align="center">
            <template slot-scope="scope">
              <div>{{ transformCuisine(device.cuisine) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="suggestion"
            label="建议使用的净化设施"
            align="center">
            <template slot-scope="scope">
              <div>{{ transformCuisine(device.cuisine) === '自助烧烤' ? '单独微型集烟机' : '低空净化器' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="suggestion"
            label="净化器图片"
            align="center">
            <template slot-scope="scope">
              <el-image
                v-if="transformCuisine(device.cuisine) === '自助烧烤'"
                style="width: 150px; height: 150px"
                :src="require('@/asset/img/barbucue_img.jpg')"
                fit="fit"/>
              <el-image
                v-else
                style="width: 150px; height: 150px"
                :src="require('@/asset/img/normalLocale.png')"
                fit="fit"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            label="商家净化器款式"
            align="center">
            <template slot-scope="scope">
              <div>{{ transformCuisine(device.cuisine) === '自助烧烤' ? '高空净化器' : '低空净化器' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="emission" label="油烟排放情况" align="center"/>
        </el-table>
      </div>
      <h4>二、餐饮企业在线监测情况汇总：</h4>
      <div class="chart-title">日浓度曲线图</div>
      <div style="margin-bottom: 17px">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-date-picker
              @change="getTenMinData"
              v-model="selDate"
              type="date"
              :default-time="['00:00:00','00:00:00']"
              placeholder="日期选择"
            />
          </el-form-item>
        </el-form>
        <div class="chart-line">
          <e-charts :options="tenMinOption" autoresize/>
        </div>
      </div>
      <div class="chart-title">历史浓度柱状图</div>
      <div>
        <el-form :inline="true" size="mini">
          <template>
            <el-form-item>
              <el-date-picker
                type="date"
                v-model="startDate"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                type="date"
                v-model="endDate"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleDateRangeSelect()"
              >查询
              </el-button>
            </el-form-item>
          </template>
        </el-form>
        <template>
          <chart :options="reduceOption" autoresize/>
        </template>
      </div>
      <h4>三、餐饮企业健康情况展示：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="showData.tableData"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="localeName" label="监测点"></el-table-column>
          <el-table-column prop="mn" label="设备编号"></el-table-column>
          <el-table-column
            prop="complianceDays"
            label="达标天数"
          ></el-table-column>
          <el-table-column
            prop="excessDays"
            label="超标天数"
          ></el-table-column>
          <el-table-column
            prop="filterAbnormallyUsedDays"
            label="净化器不正常天数"
          ></el-table-column>
          <el-table-column
            prop="abnormalOfflineDays"
            label="店家原因离线天数"
          ></el-table-column>
          <el-table-column prop="healthCodeColor" label="油烟健康码">
            <template slot-scope="scope">
              <span class="iconfont" :class="scope.row.healthCodeColor"
              >&#xe704;</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <h5>净化器需清洗黄码报警提示：</h5>
      <div style="margin-bottom: 17px">
        <el-table
          :data="showData.tableData"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="localeName" label="监测点"></el-table-column>
          <el-table-column prop="mn" label="设备编号"></el-table-column>
          <el-table-column
            prop="null"
            label="净化器需清洗"
          >
            <template slot-scope="scope">
              0
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="净化器未清洗导致超标"
          >
            <template slot-scope="scope">
              0
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="净化器清洗天数"
          >
            <template slot-scope="scope">
              0
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="净化器已洗天数"
          >
            <template slot-scope="scope">
              0
            </template>
          </el-table-column>
          <el-table-column prop="null" label="积分">
            <template slot-scope="scope">
              0
            </template>
          </el-table-column>
        </el-table>
      </div>
      <h5>超标，设备损坏红码报警提示：</h5>
      <div style="margin-bottom: 17px">
        <el-table
          :data="showData.tableData"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="localeName" label="监测点"></el-table-column>
          <el-table-column prop="mn" label="设备编号"></el-table-column>
          <el-table-column
            prop="null"
            label="超标原因"
          >
            <template slot-scope="scope">
              -
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="设备损坏原因"
          >
            <template slot-scope="scope">
              -
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="管理部门"
          >
            <template slot-scope="scope">
              -
            </template>
          </el-table-column>
          <el-table-column
            prop="null"
            label="商家进行整改"
          >
            <template slot-scope="scope">
              -
            </template>
          </el-table-column>
          <el-table-column prop="null" label="整改完成">
            <template slot-scope="scope">
              -
            </template>
          </el-table-column>
        </el-table>
      </div>
      <h4>四、现场照片：</h4>
      <div >
        <el-alert
          v-if="fileList.length===0"
          center
          show-icon
          :closable="false"
          style="margin-bottom: 8px"
          title="未上传现场照片"
          type="info"
        ></el-alert>
        <el-image
          v-else
          style="width: 300px; height: 225px; margin: 8px;"
          v-for="(item, i) in fileList"
          :key="i"
          :src="item.url"
        >
          <div slot="error" class="image-slot">
            暂无图片
          </div>
        </el-image>
      </div>
      <h4>五、上下线记录：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="record.list"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="55"/>
          <el-table-column align="center" prop="mn" label="设备编号"></el-table-column>
          <el-table-column
            align="center"
            prop="create_at"
            label="提交时间"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="user_name"
            label="提交人"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="reason"
            label="上下线原因"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="status_info"
            label="处理状态"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="handle_at"
            label="处理日期"
          ></el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <i
                title="查看"
                @click="handleView(scope.row)"
                class="opt el-icon-orange el-icon-view"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <offline-view-dialog
        :id="id"
        :visible.sync="viewVisible"
        :mode="viewMode"
        @handleClose="handleViewClose"
        :topStyle="120"
      />
      <h4>六、红码处理记录：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="redCode"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="55"/>
          <el-table-column align="center" prop="StartAt" label="起始日期" width="69" :formatter="dateFormat"></el-table-column>
          <el-table-column
            align="center"
            prop="ExcessDays"
            label="超标天数"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="FilterAbnormallyUsedDays"
            label="不正常使用净化器天数"
            width="69"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.FilterAbnormallyUsedDays || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="OfflineCausedByShopDays"
            label="店家原因离线天数"
            width="69"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.OfflineCausedByShopDays || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="VerifyAt"
            :formatter="dateFormat"
            label="核实日期"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Verifier"
            label="核实人员"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Cause"
            label="核实详情"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="HandleAt"
            :formatter="dateFormat"
            label="处理日期"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Handler"
            label="处理人员"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Resolution"
            label="处理措施"
          ></el-table-column>
          <el-table-column
            width="50"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <i
                title="查看"
                @click="handleCodeView1(scope.row.Id, 'view')"
                class="opt el-icon-orange el-icon-view"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <management-view-dialog ref="managementViewDialog" @on-refresh="getHealthCodeRecode"  :topStyle="120"/>
      <h4>七、报警管理记录：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="alarmManagement.list"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="50"/>
          <el-table-column align="center" prop="acquit_at" label="报警时间" width="69"></el-table-column>
          <el-table-column
            align="center"
            prop="event_type"
            label="报警类型"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="event_status"
            label="事件状态"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="process_at"
            label="核实时间"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="process_reason"
            label="报警原因"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="process_info"
            label="核实结果"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="rectify_desc"
            label="整改状态"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="rectify_message"
            label="整改情况"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="handle_at"
            label="执法处理时间"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="solution"
            label="执法处理情况"

          ></el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="55">
            <template slot-scope="scope">
              <i
                title="查看"
                @click="handleCodeView(scope.row.id, 'view',scope.row.locale_id,)"
                class="opt el-icon-orange el-icon-view"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <alarm-view-dialog ref="alarmViewDialog" @on-refresh="getData" :topStyle="120"/>
      <h4>八、运维记录：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="operationalRecord.content"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="50"/>
          <el-table-column align="center" prop="CreateAt" :formatter="dateFormat" label="派单日期"width="69" ></el-table-column>
          <el-table-column
            align="center"
            prop="MN"
            label="维护设备"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Typ"
            label="维护类型"
          >
            <template slot-scope="scope">
              <el-tag  v-if="scope.row.Typ === 1">维修</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 2">移机</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 3">拆机</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 6">维保</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 7">超标巡查</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 8">异常离线巡查</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 9">换机</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 10">例行巡查</el-tag>
              <el-tag  v-else-if="scope.row.Typ === 11">数据校准</el-tag>
              <el-tag  v-else>' '</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="MaintainerName"
            label="运维人员"
            width="69"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="MaintainAt"
            label="处理日期"
            :formatter="dateFormat"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="Handler"
            label="处理人员"

          ></el-table-column>
          <el-table-column
            align="center"
            prop="Status"
            label="操作状态"
            width="69"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.Status === 1">已完成</div>
              <div v-else-if="scope.row.Status === 2">未完成</div>
              <div v-else-if="scope.row.Status === 3">待处理</div>
              <div v-else>未知状态</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ExamStatus"
            label="审核状态"
            align="center"
            width="80"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.ExamStatus === 0">待审核</el-tag>
              <el-tag type="success" v-else-if="scope.row.ExamStatus === 1">通过</el-tag>
              <el-tag type="danger" v-else-if="scope.row.ExamStatus === 2">拒绝</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="55">
            <template slot-scope="scope">
              <i
                title="查看"
                @click="handleManagementLook(scope.row)"
                class="opt el-icon-orange el-icon-view"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--运维记录查看-->
      <el-dialog
        style="top:-100px;"
        width="550px"
        title="查看详情"
        :visible.sync="managementDialog.innerVisible"
        append-to-body>
        <el-form
          :model="managementDialog.innerData"
          size="mini"
          label-width="108px"
          label-position="left"
          :disabled="true"
        >
          <el-form-item prop="LocalAddr" label="所属单位">
            <el-input
              v-model="device.owner"
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-row>
            <el-col>
              <el-form-item prop="LocaleName" label="监测点名称">
                <el-input
                  v-model="managementDialog.innerData.LocaleName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="LocalAddr" label="监测点地址">
            <el-input
              v-model="managementDialog.innerData.Addr"
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="Contact" label="联系人及电话">
            <el-input
              v-model="managementDialog.innerData.Contact"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="Mobile" label=" ">
            <el-input
              v-model="managementDialog.innerData.Mobile"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="DeviceId" label="维护设备">
            <el-input
              v-model="managementDialog.innerData.DeviceId"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-form-item prop="Typ" label="维护类型">

              <span v-if="managementDialog.innerData.Typ === 1">维修</span>
              <span v-else-if="managementDialog.innerData.Typ === 2">移机</span>
              <span v-else-if="managementDialog.innerData.Typ === 3">拆机</span>
              <span v-else-if="managementDialog.innerData.Typ === 6">维保</span>
              <span v-else-if="managementDialog.innerData.Typ === 7">超标巡查</span>
              <span v-else-if="managementDialog.innerData.Typ === 8">异常离线巡查</span>
              <span v-else-if="managementDialog.innerData.Typ === 9">换机</span>
              <span v-else></span>

            </el-form-item>
          </el-row>
          <el-form-item prop="Remark" label="其他原因及目前状态备注">
            <el-input
              placeholder="其他原因及处理措施备注"
              type="textarea"
              :rows="2"
              autosize
              v-model="managementDialog.innerData.Remark"
            />
          </el-form-item>
          <el-form-item
            prop="Status"
            label="处理结果"
          >
            <span v-if="managementDialog.innerData.Status === 1">已完成</span>
            <span v-else-if="managementDialog.innerData.Status === 2">待审核</span>
          </el-form-item>
          <el-form-item
            prop="Resolution"
            label="处理措施"
          >
            <el-input
              type="textarea"
              :rows="2"
              autosize
              v-model="managementDialog.innerData.Resolution"
            ></el-input>
          </el-form-item>
          <el-form-item prop="MaintainerName" label="运维人员">
            <el-input
              v-model="managementDialog.innerData.MaintainerName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="CreateAt" label="派单日期">
            <el-date-picker
              disabled
              placeholder="派单日期"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd"
              v-model="managementDialog.innerData.CreateAt"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="CreateAt" label="处理日期">
            <el-date-picker
              placeholder="处理日期"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd"
              v-model="managementDialog.innerData.MaintainAt"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="Pos" label="定位">
            <baidu-map
              class="bm-view"
              :center="mapCenter"
              :zoom="mapZoom"
              ak="770b4c07458f53896ff0abd948755e20"
              @ready="handleMapReady"
            >
              <bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :showAddressBar="true"
                :autoLocation="true"
                @locationSuccess="getPosition"
              ></bm-geolocation>
            </baidu-map>
            <span>{{ managementDialog.innerData.Position ? managementDialog.innerData.Position : '暂无定位' }}</span>
          </el-form-item>
          <el-form-item label="图片">
            <el-image
              class="view-img"
              v-for="(item, i) in fileList1"
              :key="i"
              :src="item"
              :preview-src-list="fileList1"
            >
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </el-form-item>
        </el-form>
      </el-dialog>
      <h4>九、净化设备清洗维保记录：</h4>
      <div style="margin-bottom: 17px">
        <el-table
          :data="washData.content"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" />
          <el-table-column align="center" prop="LocaleName" label="监测点" ></el-table-column>
          <el-table-column
            align="center"
            prop="LocaleAddr"
            label="安装地址"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="CreatedAt"
            label="提交日期"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="EndDate"
            label="清洗日期"
          ></el-table-column>
          <el-table-column
            align="center"
            label="操作"
            >
            <template slot-scope="scope">
              <i
                title="查看"
                @click="lookWash(scope.row)"
                class="opt el-icon-orange el-icon-view"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :title="dlg1.title"
        :visible.sync="dlg1.visible"
      >
        <el-form
          :model="formData"
          label-width="140px"
          ref="form"
          size="mini"

        >
          <el-form-item prop="LocaleId" label="监测点" style="margin-bottom: 30px">
            <el-select
              v-model="formData.LocaleName"
              placeholder="请选择监测点"
              filterable
              disabled
            >
            </el-select>
          </el-form-item>
          <el-form-item label="清洗日期">
            <el-date-picker
              v-model="formData.EndDate"
              value-format="yyyy-MM-dd"
              type="date"
              disabled
              style="margin-bottom: 30px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="UploadType" label="类型">
            <el-select v-model="formData.UploadType" disabled style="margin-bottom: 30px">
              <el-option label="净化器清洗" value="FilterWash" ></el-option>
              <el-option
                label="歇业、停业申请"
                value="BusinessStopped"
              ></el-option>
              <el-option
                label="投诉"
                value="Complaint"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="Remark" label="备注">
            <el-input v-model.trim="formData.Remark" disabled style="margin-bottom: 30px"/>
          </el-form-item>
          <div class="img-list" v-if="formData.pics && formData.pics.length > 0">
            <div
              class="single-img"
              v-for="(item, idx) in formData.pics"
              :key="idx"
              style="
              position: relative;
              display: inline-block;
              margin-right: 10px;
            "
            >
              <img :src="item" />
              <div class="remove-img el-icon-close" @click="removeImg(idx)"></div>
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
    <div style="text-align: center;background-color: white; z-index: 1; position: sticky; margin-bottom: 20px;width:100%;">
      <el-button type="primary" @click="downloadPdf" :loading="downloading" >生成并下载pdf</el-button>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import 'v-charts/lib/style.css'
import VeHistogram from 'v-charts/lib/histogram.common'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/legend'
import {
  dateFormater,
  getPname, getUserInfo, ownerJoin
} from '@/util/index'
import dayjs from "dayjs";
import OfflineViewDialog from "@/component/offlineManagement/OfflineViewDialog.vue";
import AlarmViewDialog from "@/component/alarmManagement/AlarmViewDialog.vue";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import conf from "@/config";
import ManagementViewDialog from "@/component/healthCodeManagement/ManagementViewDialog.vue";
import chart from 'vue-echarts'


export default {
  props: ['device'],
  components: {
    chart,
    ManagementViewDialog, BmGeolocation, BaiduMap, AlarmViewDialog, OfflineViewDialog, ECharts},
  data() {
    return {
      //一点一档柱状图数据
      reduceOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['油烟折算浓度', '颗粒物折算浓度', '非甲烷总烃折算浓度']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: true,
          axisLabel: {
            interval: 0,
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '浓度 mg/m³'
        },
        series: [
          {
            name: '油烟折算浓度',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: '#00A1FF'
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#00A1FF'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c}'
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '颗粒物折算浓度',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: '#F5B049'
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#F5B049'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c}'
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '非甲烷总烃折算浓度',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: '#009999'
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#009999'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c}'
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          }
        ]
      },

      formData: {},
      dlg1: {
        visible: false,
        title: ''
      },//净化器设备清洗查看弹窗
      mapCenter: {lng: 120.306305, lat: 30.424877},
      mapZoom: 14,//运维记录的地图
      fileList1: [],
      managementDialog: {
        visible: false,
        innerVisible: false,
        loading: false,
        deviceData: null,
        maintenanceData: {},
        innerData: {}
      },//运维记录查看详情的弹窗
      index: 0, // 记录更新index
      dlg: {//运维记录查看弹窗
        visible: false,
        type: null,
        title: ''
      },
      washDialog:false,//设备清洗记录弹窗
      formLabelWidth: '120px',//运维记录查看
      record:[],//上下线记录
      redCode:[],//红码处理记录
      alarmManagement:[],//报警管理记录
      operationalRecord:[],//运维记录
      washData: [],//设备清洗维保记录
      dialogFormVisible: false,//运维单查看弹窗
      HealthCodeRecordDialog: {//红码处理记录查看弹窗
        loading: false,
        visible: false,
        data: null
      },
      viewVisible: false,//上下线记录查看弹窗
      id: null,
      viewMode: null,
      LocaleId:'',
      guideData: [{
        cuisine: '',
        emission: '达标',
        reason: '-',
        suggestion: '-'
      }],
      selDate: null,
      downloading: false, // 生成并下载pdf按钮 加载状态
      checkList: [],
      tableData: [],
      obj: {},
      cuisine: [],
      textarea01: '',
      textarea02: '',
      today: '',
      startDate: '',
      endDate: '',
      dataOption: {
        columns: [
          '采集时间',
          '油烟折算浓度',
          '颗粒物折算浓度',
          '非甲烷总烃折算浓度'
        ],
        rows: []
      },
      markLine: null,
      extend: {
        // series: {
        //   barWidth: 20
        // },
        'xAxis.0.axisLabel.rotate': 45
      },
      grid: {
        show: true,
        top: 50,
        left: 10
      },
      chartLineSettings: {
        metrics: ['浓度曲线'],
        dimension: ['采集时间'],
        yAxisName: ['平均浓度mg/m³']
      },
      tenMinOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['油烟浓度', '颗粒物浓度', '非甲烷总烃浓度']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: true,
          axisLabel: {
            interval: 17
          }
        },
        yAxis: {
          type: 'value',
          // min: 5,
          // data : [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4,5],
          name: '平均浓度mg/m³'
        },
        series: [
          {
            name: '油烟浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#00A1FF',
                lineStyle: {
                  type: 'solid',
                  color: '#00A1FF'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#00A1FF'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '颗粒物浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#F5B049',
                lineStyle: {
                  type: 'solid',
                  color: '#F5B049'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#F5B049'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '非甲烷总烃浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#009999',
                lineStyle: {
                  type: 'solid',
                  color: '#009999'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#009999'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          }
        ]
      },
      showData: {
        tableData: [],
      },
      fileList: [],
      customForm: null,
      localeForm: null,
      manageData: null,
      rectificationData: null
    }
  },
  watch: {
    device: {
      handler: function (value) {
        this.getDeviceData(value)
      },
      immediate: true
    }
  },
  filters: {
    filter(type) {
      const op = {
        1: '一般监测点',
        2: '特殊监测点',
        99: '废弃监测点'
      }
      return op[type]
    }
  },
  computed: {
    ...mapState(['customerTree'])
  },
  created() {
    this.getxDates(31)
    this.$get('admin/listAllCuisine').then((res) => {
      this.cuisine = res
    })
  },
  methods: {
    getDeviceData(v) {
      // 由于各组件命名不同，此处的Id为监测点Id(LocaleId)
      if (!v.id) return
      const data = v
      const nowDate = new Date()
      const now = nowDate.getTime()
      const last = now - 7 * 24 * 3600 * 1000
      const lastDate = new Date(last)
      let yy = lastDate.getFullYear()
      let mm = lastDate.getMonth() + 1
      let dd = lastDate.getDate()
      this.startDate = `${yy}-${mm}-${dd}`
      yy = nowDate.getFullYear()
      mm = nowDate.getMonth() + 1
      dd = nowDate.getDate()
      this.endDate = `${yy}-${mm}-${dd}`
      this.selDate = this.endDate
      const par = {
        LocaleId: data.id,
        AcquitAtBegin: parseInt(last / 1000),
        AcquitAtEnd: parseInt(now / 1000)
      }
      this.customForm = {}
      this.$post('admin/listDataDetectorDailySumDaysByLocaleId', par)
      .then((res) => {
        this.customForm.Contact = res.customer.Contact
        this.customForm.Mobile = res.customer.Mobile
        this.handleDateRangeSelect()
      })
      .catch(() => {
      })

      // 近15日
      const last30 = now - 15 * 24 * 3600 * 1000
      const par30 = {
        LocaleId: data.id,
        AcquitAtBegin: parseInt(last30 / 1000),
        AcquitAtEnd: parseInt(now / 1000)
      }
      const list = []
      //餐饮企业健康情况展示接口
      this.$post('admin/listDataDetectorDailySumDaysByLocaleId', par30)
      .then((res) => {
        list.push(res)
        this.showData.tableData = list
      })
      .catch(() => {
      })
      //5月11新增上下线记录
      this.$get('admin/offline_apply',{"locale_id": data.id}).then(res => {//{"locale_id":this.LocaleId}
        this.record = res
      }).catch(() => {

      })
      //5月13新增红码处理记录
      const payload = {
        Param: {}
      }
      if (data.id) {
        payload.Param['health_code_maintenance.locale_id'] = {S: 0, V: `'${data.id}'`}
      }
      this.$post('admin/listHealthCodeRecord',payload).then((res) => {
        this.redCode = res.content
      }).catch(() => {

      })

      //5月13新增报警管理记录
      this.$get("admin/alarmManagement/list",{"owner":data.owner}).then(res => {
        this.alarmManagement = res
      }).catch(() => {

      })
      //5月13新增运维记录
      const operational = {
        FormType: 1,
        Param: {}
      }
      if (data.owner) {
        operational.Param['maintenance.owner'] = {S: 4, V: `${data.owner}`}
      }
      this.$post('admin/listMaintenance', operational).then((res) => {
        this.operationalRecord = res
      }).catch(() => {

      })

      this.getTenMinData()
      this.$post('admin/queryLocaleUploadedInfo', {"LocaleName": data.name}).then((res) => {
        this.washData = res
      }).catch(() => {
      })

      this.fileList = []
      this.localeForm = {}
      const param = {Param: {id: data.id}}
      this.$post('admin/listLocale', param)
        .then((res) => {
          const urls = res.content[0].LocalePicS || []
          urls.forEach((item) => {
            this.fileList.push({url: item})
          })
          this.localeForm = res.content[0]
          if (res.content[0].Owner) {
            this.localeForm.Owner = getPname(
              this.customerTree,
              res.content[0].Owner,
              'Org'
            ).join('/')
          }
        })
        .catch(() => {
        })
    },
    // 用于将时间戳转换为YY-MM-DD
    dateFormat(r, c) {
      return dateFormater(r[c.property])
    },
    // 一点一档上下线记录操作查看的弹窗
    handleView(row) {
      this.id = row.id
      this.viewVisible = true
      this.viewMode = 'view'
    },
    // 关闭一点一档上下线记录操作查看的弹窗
    handleViewClose() {
      this.viewVisible = false
      this.getData()
    },
    //报警管理记录查看弹窗
    getData() {
      this.loading = true
      let param = Object.assign({}, this.filter)
      if (param.owner.length !== 0) {
        let userInfo = getUserInfo().Info
        param.owner = ownerJoin(param.owner, userInfo)
      }

      if (param.start_time) {
        param.end_time = dayjs(param.start_time).add(1, 'day').unix()
        param.start_time = dayjs(param.start_time).unix()
      }

      this.$get('admin/offline_apply', param).then(res => {
        this.tableData = res.list
        this.total = res.count
        this.loading = false
      })
    },
    // 红码处理记录
    handleShowHealthCodeRecord(row) {
      this.healthCodeInfo = row
      this.getHealthCodeRecode()
    },
    getHealthCodeRecode() {
      this.HealthCodeRecordDialog.loading = true
      this.HealthCodeRecordDialog.visible = true
      const payload = {
        Param: {}
      }
      if (this.healthCodeInfo.LocaleId) {
        payload.Param['health_code_maintenance.locale_id'] = {S: 0, V: `'${this.healthCodeInfo.LocaleId}'`}
      }
      this.$post('admin/listHealthCodeRecord', payload).then(res => {
        this.HealthCodeRecordDialog.data = res.content
        this.HealthCodeRecordDialog.loading = false
      })
    },
    //红码处理记录查看弹窗
    handleCodeView1(id, mode) {
      this.$refs['managementViewDialog'].dealDialog(mode, { id: id })
    },
    //报警管理查看弹窗
    handleCodeView(id, mode,localeId) {
      this.$refs['alarmViewDialog'].dealDialog(mode, { id: id ,localeId: localeId})
    },
    // 运维记录查看弹窗
    // handleLook(){
    //   this.dialogFormVisible = true
    // },
    //查看运维记录弹窗
    handleManagementLook(row) {
      this.managementDialog.innerVisible = true
      this.managementDialog.innerData = Object.assign({}, row, {
        MaintenancePics: []
      })
      this.fileList1 = row.MaintenancePicS//this.fileList1是存储的图片的网址
    },

    handleMapReady() {
      if (this.managementDialog.innerVisible.Lng && this.managementDialog.innerVisible.Lat) {
        this.mapCenter = {lng: this.managementDialog.innerVisible.Lng, lat: this.managementDialog.innerVisible.Lat}
      }
    },
    getPosition(pos) {
      this.managementDialog.innerVisible.Lng = pos.point.lng.toString()
      this.managementDialog.innerVisible.Lat = pos.point.lat.toString()
      this.managementDialog.innerVisible.Position = pos.addressComponent['province'] + pos.addressComponent['city'] +
        pos.addressComponent['district'] + pos.addressComponent['street'] +
        pos.addressComponent['streetNumber']
    },
    //查看清洗记录
    lookWash:function(scope){
      this.dlg1.title = '查看'
      this.formData = {}
      this.dlg1.visible = true
      this.formData = Object.assign({}, scope)
      this.formData.pics = [...scope.LocaleUploadedInfoPicS, ...scope.LocaleUploadedInfoBeforePicS, ...scope.LocaleUploadedInfoOtherPicS]
      console.log(this.formData.pics)
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    handleAvatarSuccess(res, file) {
      if (this.fileList.length < 4) {
        this.fileList.push(res.Data)
      } else {
        this.$message.warning(`照片数量限制在4张`)
      }
    },
    removeImg(idx) {
      //   this.changeState = true;
      this.fileList.splice(idx, 1)
    },
    /**
     * @description 生成并下载pdf
     */
    // 生成下载pdf
    downloadPdf() {
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      this.downloading = true
      this.ExportSavePdf(this.$refs.notificationDialog, '一点一档').then(
        () => {
          setTimeout(() => {
            //关闭加载中动画
            loading.close()
            this.downloading = false
            this.handleClose()
          }, 500)
        }
      )
    },
    //this.$refs.notificationDialog.clearSelection()

    /**
     * @description 关闭对话框
     */
    handleClose() {

      this.$emit('on-close', false)
    },
    getxDates(n) {
      const day = new Date()
      const yy = day.getFullYear()
      const mm = day.getMonth() + 1
      const dd = day.getDate()
      this.today = `${yy}年${mm}月${dd}日`
    },
    getTenMinData() {
      let tpl, url
      tpl = {
        localeId: this.device.id,
        at: dayjs(this.selDate).unix()
      }
      url = 'admin/listTenMinData'
      this.$post(url, tpl).then((response) => {
        this.tenMinOption.series[0]['data'] = []
        this.tenMinOption.series[0]['markLine']['data'][0]['yAxis'] = this.device.emissions_sill || 0
        this.tenMinOption.xAxis['data'] = []
        this.tenMinOption.xAxis['axisLabel']['interval'] = 143
        this.tenMinOption.series[1]['data'] = []
        this.tenMinOption.series[1]['markLine']['data'][0]['yAxis'] = this.device.granule_sill || 0
        this.tenMinOption.series[2]['data'] = []
        this.tenMinOption.series[2]['markLine']['data'][0]['yAxis'] = this.device.hydrocarbon_sill  || 0
        if (response && response.length !== 0) {
          if (this.selDate === null) {
            this.selDate = new Date(
              new Date(res[0]['acquit_at'] * 600 * 1000).setHours(0, 0, 0, 0)
            ).getTime()
          }
          const t = new Date(this.selDate)
          t.setHours(0, 0, 0, 0)
          const endTime = Math.floor(t.getTime() / 600000) + 143
          for (var i = Math.floor(t.getTime() / 600000); i <= endTime; i++) {
            let obj = {
              emissions_conc: 0,
              granule_conc: 0,
              hydrocarbon_conc: 0,
              counter: 1
            }
            response.forEach(e => {
              if (e.acquit_at === i) {
                obj = e
              }
            })
            this.tenMinOption.series[0]['data'].push(
              (obj.emissions_conc).toFixed(2)
            )
            this.tenMinOption.series[1]['data'].push(
              (obj.granule_conc).toFixed(2)
            )
            this.tenMinOption.series[2]['data'].push(
              (obj.hydrocarbon_conc).toFixed(2)
            )
            this.tenMinOption.xAxis['data'].push(dateFormater(i * 600, true, false))
          }
          this.$forceUpdate()
        }
      })
    },
    // 历史柱状图时间查询
    handleDateRangeSelect() {
      const tpl = { localeId: this.device.id };
      tpl['AcquitAtBegin'] = parseInt(new Date(this.startDate + ' 00:00:00').getTime() / 1000);
      tpl['AcquitAtEnd'] = parseInt(new Date(this.endDate + ' 23:59:59').getTime() / 1000);

      this.$post('admin/queryDataDetectorDaily', tpl).then((res) => {
        this.showData = Object.assign({}, this.showData, this.customForm, this.localeForm);
        this.showData.LocaleId = tpl.localeId;
        this.showData.beginDate = dateFormater(tpl['AcquitAtBegin'], false);
        this.showData.endDate = dateFormater(tpl['AcquitAtEnd'], false);

        let data;

        // 清空旧数据
        this.reduceOption.xAxis.data = [];
        this.reduceOption.series[0].data = [];
        this.reduceOption.series[1].data = [];
        this.reduceOption.series[2].data = [];

        for (var i = tpl['AcquitAtBegin']; i <= tpl['AcquitAtEnd']; i += 86400) {
          data = res.find((e) => dateFormater(e.AcquitAt, false) === dateFormater(i, false));

          const dateStr = dateFormater(i, false);
          this.reduceOption.xAxis.data.push(dateStr);

          this.reduceOption.series[0].data.push(data ? data.CEmissions : 0);
          this.reduceOption.series[1].data.push(data ? data.CGranule : 0);
          this.reduceOption.series[2].data.push(data ? data.CHydrocarbon : 0);
        }

        // 更新 markLine 阈值
        this.reduceOption.series[0].markLine.data[0].yAxis = res[0].LocaleEmissionsSill || 0;
        this.reduceOption.series[1].markLine.data[0].yAxis = res[0].LocaleGranuleSill || 0;
        this.reduceOption.series[2].markLine.data[0].yAxis = res[0].LocaleHydrocarbonSill || 0;

        this.$forceUpdate();
      });
    },
    transformCuisine(k) {
      for (let i = 0, len = this.cuisine.length; i < len; i++) {
        if (this.cuisine[i].Id === k) {
          return this.cuisine[i].Name
        }
      }
      return ''
    },
    showImagesInViewer(images) {
      console.log(images)
    }
  }

}
</script>
<style lang="scss" scoped>
#mytitle {
  position: absolute;
  color: #ffffff;
  max-width: 160px;
  font-size: 14px;
  padding: 4px;
  background: rgba(40, 40, 40, 0.8);
  border: solid 1px #e9f7f6;
  border-radius:5px;
}
.single-img > img {
  width: 160px;
  height: 160px;
}
.checkbox_group_box {
  font-size: inherit;

  .el-checkbox {
    display: block;
  }
}
.el-icon-orange {
  color: #409eff;
}

.notification_dialog {
  background-color: #ffffff;
  .notification_dialog_content {
    font-size: 13px;

    .el-form-item {
      margin-bottom: 0;

      .el-form-item__content {
        span {
          line-height: 40px;
        }
      }
    }

    h2 {
      text-align: center;
      font-size: 28px;
    }

    h4 {
      font-size: 20px;
      //margin: 16px 0 12px;
      margin-left: 38px;
      margin-bottom: 17px;
    }

    h5 {
      font-size: 13px;
      margin: 5px 0;
      margin-bottom: 17px;
    }

    p {
      margin: 5px 0;
    }

    .date_box {
      text-align: right;
      padding: 10px 0;
      margin-top: 20px;
      font-weight: bold;
      font-weight: 15px;
    }

    .chart-title {
      font-size: 16px;
      font-weight: bold;
      margin: 12px auto;
      text-align: center;
    }

    .one-third {
      width: 33%;
    }
  }
}
</style>
<style>
.echarts {
  width: 100% !important;
}
</style>
